import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideModal } from '../../../../../../actions/modalsActions';
import { Formik, Form, Field } from 'formik';
import { Form as bootStrapForm, Col, Button, Spinner } from 'react-bootstrap';
import * as yup from 'yup';

//imported Comps
import ImageUpload from '../../../../../ImageUpload';

const schema = yup.object({
    name: yup.string().required(),
    url: yup.string().url(),
    category: yup.string().required(),
});

function EditSourceForm({ onSubmit, source }) {

    //redux state
    const currentuser = useSelector(state => state.currentuser);
    const accessToken = useSelector(state => state.accessToken);
    //comp. state
    const [updated, setUpdated] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [image, setImage] = useState(source.image);
    const [imageError, setImageError] = useState('');
    const dispatch = useDispatch();

    const renderTextField = ({ field, form, meta, checkHidden }, label) => {
        return (
            <bootStrapForm.Group>
                {/* <bootStrapForm.Label>{label}</bootStrapForm.Label> */}
                <bootStrapForm.Control isInvalid={meta.touched && meta.error} {...field} type="text" placeholder={label} />
                {meta.touched && meta.error && <div className="error" style={{ color: '#ff4040' }}>{meta.error}</div>}
            </bootStrapForm.Group>
        )
    }

    const renderDropDown = ({ field, form, meta, checkHidden }, label, dropdownOptions) => {
        return (
            <bootStrapForm.Group controlId="formGrid">
                {/* <bootStrapForm.Label>{label}</bootStrapForm.Label> */}
                <bootStrapForm.Control isInvalid={meta.touched && meta.error} as="select" {...field} type="select" placeholder={label}>
                    <option value="">{label}</option>
                    {dropdownOptions.map(el => <option key={el} value={el}>{el}</option>)}
                </bootStrapForm.Control>
                {meta.touched && meta.error && <span style={{ color: 'red' }}>{meta.error}</span>}
            </bootStrapForm.Group>
        )
    }

    const onImageUploadClick = (image) => {
        setImage(image);
        if (imageError) setImageError('')
    }

    return (
        <Formik
            validationSchema={schema}
            // validate={values => validate(values)}
            onSubmit={async (values, { resetForm }) => {
                if (!image) {
                    return setImageError('Please Upload Image')
                }
                onSubmit(values, image)
                setUpdated(true);
                setTimeout(() => { setUpdated(false) }, 3000)
                resetForm();
                dispatch(hideModal())
            }}
            initialValues={{
                name: source.name,
                url: source.url,
                category: source.category,
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                setValues,
                touched,
                isValid,
                errors,
                validateField,
                isSubmitting,
                helpers
            }) => (
                    <Form autoComplete="off">
                        <div className="row">
                            <div className="col-md-8 pr-md-2">
                                <Field name="name">
                                    {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Site Name*')}
                                </Field>
                                <Field name="url">
                                    {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Site Url*')}
                                </Field>
                                <Field name="category">
                                    {({ field, form, meta }) => renderDropDown({ field, form, meta }, 'Category*', ['TruKno Pick', 'Individual', 'Government', 'Media', 'Vendor'])}
                                </Field>
                            </div>
                            <div className="col-md-4 pr-md-2">
                                <div style={{ boxShadow: '0 5px 10px 2px rgba(195,192,192,.5)', maxWidth: '180px' }}>
                                    <p style={{ color: '#555', fontSize: '12px', textAlign: 'center' }}>Upload Logo</p>
                                    <img className="mx-4" src={image} alt="item Image" style={{ width: '100px', height: '100px', display: 'block', textAlign: 'center' }} />
                                    <ImageUpload onImageUploadClick={onImageUploadClick} alertContainer="oc-alert-container1" />
                                    {/* For Alert box*/}
                                    <div id="oc-alert-container1"></div>
                                </div>
                                {imageError && <p className="text-red">{imageError}</p>}
                            </div>
                        </div>



                        <div className="d-flex flex-column justify-content-center  align-items-center pb-4">

                            <Button variant="primary" type="submit" size="lg" className="mt-4">
                                Submit
                                {submitting ? <Spinner className="ml-3" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                            </Button>
                        </div>
                    </Form>
                )}
        </Formik>
    );
}

export default EditSourceForm;
